var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 39,
    viewBox: "0 0 36 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.6,
    d: "M31.2 24c0 7.511-6.089 13.6-13.6 13.6C10.089 37.6 4 31.511 4 24c0-7.511 6.089-13.6 13.6-13.6 7.511 0 13.6 6.089 13.6 13.6z",
    transform: "translate(-549 -1553) translate(549 1553)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.8 9.6c0 1.326-1.074 2.4-2.4 2.4C1.074 12 0 10.926 0 9.6c0-1.326 1.074-2.4 2.4-2.4 1.326 0 2.4 1.074 2.4 2.4M20 2.4c0 1.326-1.074 2.4-2.4 2.4-1.326 0-2.4-1.074-2.4-2.4 0-1.326 1.074-2.4 2.4-2.4C18.926 0 20 1.074 20 2.4M35.2 9.6c0 1.326-1.074 2.4-2.4 2.4-1.326 0-2.4-1.074-2.4-2.4 0-1.326 1.074-2.4 2.4-2.4 1.326 0 2.4 1.074 2.4 2.4",
    transform: "translate(-549 -1553) translate(549 1553)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.6,
    d: "M19.28 22.32L27.2 14.4",
    transform: "translate(-549 -1553) translate(549 1553)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClasses);
export default __webpack_public_path__ + "static/media/classes.bca10b0d67ceab22587e01dd99f5d5d9.svg";
export { ForwardRef as ReactComponent };